export default __webpack_public_path__ + "static/media/bg.444f635a.png";